import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { NavigationBar, NavigationBarColor } from '@capgo/capacitor-navigation-bar';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';

export const updateStatusBarStyle = async (isDarkMode: boolean) => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  try {
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: isDarkMode ? '#181818' : '#ffffff' });
      await StatusBar.setStyle({ style: isDarkMode ? Style.Dark : Style.Light });
      await StatusBar.setOverlaysWebView({ overlay: false });
      await NavigationBar.setNavigationBarColor({ color: isDarkMode ? NavigationBarColor.BLACK : NavigationBarColor.WHITE, darkButtons: !isDarkMode });
      await EdgeToEdge.setBackgroundColor({ color: isDarkMode ? '#181818' : '#ffffff' });
    } else {
      await StatusBar.setOverlaysWebView({ overlay: true });
    }
  } catch (error) {
    console.warn('Failed to update status bar style:', error);
  }
}; 